<template>
  <div class="container">
    <r-process :dataArr="processData"></r-process>
    <el-card shadow="never" class="card">
      <span>Trans#:{{ $route.query.bpmId }}</span>
    </el-card>
    <el-card shadow="never" class="card" header="BASIC INFORMATION">
      <customize-form-info
        ref="userInfoForm"
        :infoData="_basicInfoData"
        :isExtra="true"
      >
        <template v-slot:cosnameSlot v-if="basicInfoData.length">
          <span class="customerId" @click="goSnapShot(companydata)">
            {{ companydata.name }}
          </span>
        </template>
      </customize-form-info>
    </el-card>
    <el-card shadow="never" class="card" header="JAPAN" v-if="isJapan">
      <customize-form-info
        ref="japanInfoForm"
        :infoData="_japanInfo"
      ></customize-form-info>
    </el-card>
    <el-card
      shadow="never"
      class="card"
      header="RISK MITIGATION"
      v-if="this.auditStatus !== 5"
    >
      <customize-form-info
        v-for="(item1, index) in riskInfo1"
        :key="index"
        ref="riskInfoForm"
        :infoData="a(item1)"
      ></customize-form-info>
      <customize-form-info
        v-for="(item2, index) in riskInfo2"
        :key="index"
        ref="riskInfoForm"
        :infoData="a(item2)"
      ></customize-form-info>
    </el-card>
    <el-card
      shadow="never"
      class="card"
      header="FINANCIAL SCORES"
      v-if="this.auditStatus !== 5"
    >
      <customize-form-info :infoData="_scoreInfo"></customize-form-info>
    </el-card>
    <el-card
      shadow="never"
      class="card"
      header="RECENT CREDIT LINE"
      v-if="this.auditStatus !== 5"
    >
      <customize-form-info :infoData="_creditLineInfo"></customize-form-info>
    </el-card>
    <el-card
      shadow="never"
      class="card"
      header="REQUESTOR COMMENTS"
      v-if="this.auditStatus !== 5"
    >
      <html-content :content="content" :token="token" />
      <customize-form
        :isShowForm="true"
        :schema="submitFormModel"
        ref="submitterComments"
      >
        <template v-slot:fileListSlot v-if="submitterFileList.length">
          <p
            class="fileItem"
            @click="fileClick(item)"
            v-for="(item, index) in submitterFileList"
            :key="index"
          >
            <i class="el-icon-document"></i>
            {{ item.name }}
          </p>
        </template>
      </customize-form>
    </el-card>
    <el-card
      shadow="never"
      class="card"
      header="CREDIT ANALYST COMMENTS"
      v-if="this.auditStatus !== 5"
    >
      <quill-editor
        ref="quillEditor"
        :initContent="analystComments"
        :token="token"
        :audit-status="this.auditStatus"
        v-if="this.auditStatus !== 5"
      ></quill-editor>
      <customize-form
        :isShowForm="true"
        :schema="commentsModel"
        ref="analysisComments"
        :disabled="this.auditStatus === 3 || this.auditStatus === 4"
      >
        <template
          v-slot:uploadSlot
          v-if="this.auditStatus === 3 || this.auditStatus !== 4"
        >
          <el-upload
            ref="upload"
            :action="uploadUrl"
            :headers="{ Authorization: $store.state.token }"
            :auto-upload="true"
            :show-file-list="true"
            :on-exceed="handleNewBeyond"
            :limit="15"
            :on-preview="handlePreview"
            :on-change="handleAnaChange"
            :before-remove="beforeRemove"
            :on-remove="handleRemove"
            :file-list="anaFileList"
            :data="{ type: anaForm.type }"
            :on-success="anaUploadSuccess"
          >
            <customize-button class="upload">Add Attachment</customize-button>
          </el-upload>
        </template>
      </customize-form>
    </el-card>
    <el-card shadow="never" class="card" header="REQUEST DETAIL">
      <customize-form-info :infoData="_requestDetailInfo"></customize-form-info>
    </el-card>
    <el-card
      shadow="never"
      class="card"
      header="DECISIONS"
      v-if="this.auditStatus !== 5"
    >
      <customize-form
        :isShowForm="true"
        ref="decisionForm"
        :schema="decisionFormModel"
        :disabled="this.auditStatus === 3 || this.auditStatus === 4"
      >
        <p style="font-size: 14px; margin-bottom: 20px">Comments:</p>
        <quill-editor
          ref="decisionComments"
          :initContent="decisionComment"
          :token="token"
          :audit-status="this.auditStatus"
          v-if="this.auditStatus !== 5"
        ></quill-editor>
        <template
          v-slot:uploadSlot
          v-if="this.auditStatus === 3 || this.auditStatus !== 4"
        >
          <el-upload
            ref="uploadDecision"
            :action="uploadUrl"
            :headers="{ Authorization: $store.state.token }"
            :auto-upload="true"
            :on-preview="handlePreview"
            :limit="5"
            :on-exceed="handleBeyond"
            :show-file-list="true"
            :before-remove="beforeRemove"
            :on-remove="handleDecRemove"
            :on-change="handleDecisionChange"
            :file-list="decisionFileList"
            :on-success="decisionUploadSuccess"
          >
            <customize-button class="upload">Add Attachment</customize-button>
          </el-upload>
        </template>
      </customize-form>
    </el-card>
    <template>
      <el-card
        shadow="never"
        class="cart-header-wrapper"
        v-show="
          this.showAddition ||
          this.decisionType_ === 4 ||
          this.decisionType_ === 1 ||
          this.decisionType_ === 3 ||
          this.decisionType_ === 8
        "
      >
        <p class="title" style="margin-bottom: 24px">ADDITIONAL CONDITIONS</p>
        <p class="label">Condition Type:</p>
        <el-form
          :model="additionalForm"
          :rules="additionalRules"
          :inline="true"
          ref="additionalForm"
        >
          <el-form-item prop="selectedConditions" label="Additional Conditions">
            <el-select
              v-model="additionalForm.selectedConditions"
              multiple
              placeholder="select"
              class="con-select"
              @change="conditionChange"
            >
              <el-option
                v-for="item in conditionTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <!--          addition conditions具体form表单-->
        <AFS
          ref="AFS"
          v-if="this.conditionNameList.includes('AFS')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'AFS',
            )
          "
        />
        <AREV
          ref="AREV"
          v-if="this.conditionNameList.includes('AREV')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'AREV',
            )
          "
        />
        <BG
          ref="BG1"
          v-if="this.conditionNameList.includes('BG1')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'BG1',
            )
          "
        />
        <BG2
          ref="BG2"
          v-if="this.conditionNameList.includes('BG2')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'BG2',
            )
          "
        />
        <BG3
          ref="BG3"
          v-if="this.conditionNameList.includes('BG3')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'BG3',
            )
          "
        />
        <CERT
          ref="CERT"
          v-if="this.conditionNameList.includes('CERT')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'CERT',
            )
          "
        />
        <CI
          ref="CI"
          v-if="this.conditionNameList.includes('CI')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'CI',
            )
          "
        />
        <CMA
          ref="CMA"
          v-if="this.conditionNameList.includes('CMA')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'CMA',
            )
          "
        />
        <COVT
          ref="COVT"
          v-if="this.conditionNameList.includes('COVT')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'COVT',
            )
          "
        />
        <DP
          ref="DP"
          v-if="this.conditionNameList.includes('DP')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'DP',
            )
          "
        />
        <F43
          ref="F43"
          v-if="this.conditionNameList.includes('F43')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'F43',
            )
          "
        />
        <F72
          ref="F72"
          v-if="this.conditionNameList.includes('F72')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'F72',
            )
          "
        />
        <FCOV
          ref="FCOV"
          v-if="this.conditionNameList.includes('FCOV')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'FCOV',
            )
          "
        />
        <GLPG
          ref="GLPG"
          v-if="this.conditionNameList.includes('GLPG')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'GLPG',
            )
          "
        />
        <GPG
          ref="GPG"
          v-if="this.conditionNameList.includes('GPG')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'GPG',
            )
          "
        />
        <HFS
          ref="HFS"
          v-if="this.conditionNameList.includes('HFS')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'HFS',
            )
          "
        />
        <HREV
          ref="HREV"
          v-if="this.conditionNameList.includes('HREV')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'HREV',
            )
          "
        />
        <MSC1
          ref="MSC1"
          v-if="this.conditionNameList.includes('MSC1')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'MSC1',
            )
          "
        />
        <MSC2
          ref="MSC2"
          v-if="this.conditionNameList.includes('MSC2')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'MSC2',
            )
          "
        />
        <MSC3
          ref="MSC3"
          v-if="this.conditionNameList.includes('MSC3')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'MSC3',
            )
          "
        />
        <UPLMSC
          ref="UPLMSC"
          v-if="this.conditionNameList.includes('UPLMSC')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'UPLMSC',
            )
          "
        />
        <PFIN
          ref="PFIN"
          v-if="this.conditionNameList.includes('PFIN')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'PFIN',
            )
          "
        />
        <PN
          ref="PN"
          v-if="this.conditionNameList.includes('PN')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'PN',
            )
          "
        />
        <POWC
          ref="POWC"
          v-if="this.conditionNameList.includes('POWC')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'POWC',
            )
          "
        />
        <PT1
          ref="PT1"
          v-if="this.conditionNameList.includes('PT1')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'PT1',
            )
          "
        />
        <QFS
          ref="QFS"
          v-if="this.conditionNameList.includes('QFS')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'QFS',
            )
          "
        />
        <QREV
          ref="QREV"
          v-if="this.conditionNameList.includes('QREV')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'QREV',
            )
          "
        />
        <REF
          ref="REF"
          v-if="this.conditionNameList.includes('REF')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'REF',
            )
          "
        />
        <ROT
          ref="ROT"
          v-if="this.conditionNameList.includes('ROT')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'ROT',
            )
          "
        />
        <SBLC
          ref="SBLC"
          v-if="this.conditionNameList.includes('SBLC')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'SBLC',
            )
          "
        />
        <SG
          ref="SG"
          v-if="this.conditionNameList.includes('SG')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'SG',
            )
          "
        />
        <TC
          ref="TC"
          v-if="this.conditionNameList.includes('TC')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'TC',
            )
          "
        />
        <TRX
          ref="TRX"
          v-if="this.conditionNameList.includes('TRX')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'TRX',
            )
          "
        />
        <UPL
          ref="UPL"
          v-if="this.conditionNameList.includes('UPL')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'UPL',
            )
          "
        />
        <VT1
          ref="VT1"
          v-if="this.conditionNameList.includes('VT1')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'VT1',
            )
          "
        />
        <XROT
          ref="XROT"
          v-if="this.conditionNameList.includes('XROT')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'XROT',
            )
          "
        />
        <ARD
          ref="ARD"
          v-if="this.conditionNameList.includes('ARD')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'ARD',
            )
          "
        />
        <BCL
          ref="BCL"
          v-if="this.conditionNameList.includes('BCL')"
          :d_value="
            this.additionalConditionsVOList.find(
              item => item.conditionTypeStr === 'BCL',
            )
          "
        />
      </el-card>
    </template>
    <template></template>
    <div
      class="btnArea"
      v-if="
        this.auditStatus === 1 ||
        this.auditStatus === 2 ||
        this.auditStatus === 6 ||
        this.auditStatus === 8
      "
    >
      <customize-button
        type="primary"
        @click="() => handleUpdate(false)"
        v-if="this.isUpdateDecisionBtn"
        :loading="isLoading"
      >
        Update Decision
      </customize-button>
      <customize-button
        type="primary"
        @click="() => handleUpdate(true)"
        :loading="isLoading"
        v-if="this.isUpdateBtn"
      >
        Update
      </customize-button>
      <customize-button
        type="primary"
        @click="handleSave"
        class="botBtn"
        v-if="this.isSaveBtn"
      >
        Save
      </customize-button>
      <customize-button @click="showResign = true" v-if="this.isReassignBtn">
        Reassign
      </customize-button>
    </div>
    <el-dialog title="Reassign" :visible.sync="showResign" width="480px">
      <customize-form ref="resignForm">
        <template v-slot:vagueSearch>
          <el-select
            v-model="reassignForm.reassignName"
            filterable
            remote
            reserve-keyword
            placeholder="Search"
            :remote-method="remoteActiveName"
            style="width: 100%; margin-bottom: 20px"
          >
            <el-option
              v-for="item in optionsActiveName"
              :key="item.id"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
      </customize-form>
      <div class="btnArea">
        <customize-button @click="showResign = false">Cancel</customize-button>
        <customize-button type="primary" @click="handleResign">
          Reassign
        </customize-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import RProcess from '../../../components/r-process/r-process'
import config from '@/config'
import { ERR_OK } from '@/utils/request'
import { getSelectList } from '@/api'
import {
  getCssDetail,
  getCusInfo,
  resignAudit,
  getFile,
  cssAudit,
  finalAuditSave,
  vagueActiveName,
  getCompletedUpdate,
  getAddlog,
} from './api'
import {
  AFS,
  AREV,
  BG,
  BG2,
  BG3,
  CERT,
  CI,
  CMA,
  COVT,
  DP,
  F43,
  F72,
  FCOV,
  GLPG,
  GPG,
  HFS,
  HREV,
  MSC1,
  MSC2,
  MSC3,
  UPLMSC,
  PFIN,
  PN,
  BCL,
  POWC,
  PT1,
  QFS,
  QREV,
  REF,
  ROT,
  SBLC,
  SG,
  TC,
  TRX,
  UPL,
  VT1,
  XROT,
  ARD,
} from './components'
import mixins from '../mixins/mixins'
// import dayjs from 'dayjs'
import htmlContent from 'views/credit-management/credit-audit/html-content'
import quillEditor from 'components/quill-editor/QuillEditor.vue'

export default {
  name: 'credit-audit',
  mixins: ['mixins'],
  components: {
    RProcess,
    AFS,
    AREV,
    BG,
    BG2,
    BG3,
    BCL,
    CERT,
    CI,
    CMA,
    COVT,
    DP,
    F43,
    F72,
    FCOV,
    GLPG,
    GPG,
    HFS,
    ARD,
    HREV,
    MSC1,
    MSC2,
    MSC3,
    UPLMSC,
    PFIN,
    PN,
    POWC,
    PT1,
    QFS,
    QREV,
    REF,
    ROT,
    SBLC,
    SG,
    TC,
    TRX,
    UPL,
    VT1,
    XROT,
    htmlContent,
    quillEditor,
  },
  data() {
    const basicInfoKeys = [
      'code',
      'name',
      'businessStr',
      'regionStr',
      'countryStr',
      'paymentTermReq',
    ]
    const outerKeys = ['totalAR', 'totalBacklog', 'totalExposure']
    const companyDetailKeys = [
      'averageOverdueRatioLast12',
      'overdueAmount60',
      'paytrendOrAverageAging',
    ]
    const japanKeys = [
      'totalOverdueAmt60',
      'tdbRating',
      'latestFYTotalProfit',
      'latestFDate',
      'latestFYTotalRevenue',
      'latestFYTotalCapital',
    ]
    const riskKeys1 = [
      'collateralAmount',
      'collateralCategoryStr',
      'expirationDate',
      'currency',
    ]
    const riskKeys2 = [
      'insuranceAmount',
      'insuranceProviderStr',
      'expirationDate',
      'currency',
    ]
    const scoreKeys = [
      'sp',
      'moodysStr',
      'fitchStr',
      'frisk',
      'zscore',
      'zscoreSecond',
      'scoreCard',
      'theoreticalLimit',
    ]
    const submitFormModel = [
      // {
      //   key: 'remark',
      //   label: '',
      //   type: 'textarea',
      //   value: '',
      //   readonly: true,
      //   disabled: true,
      //   rules: [
      //     {
      //       min: 0,
      //       max: 20000,
      //       message: 'No more than 20000 characters.',
      //       trigger: 'blur',
      //     },
      //   ],
      // },
    ]
    const commentsModel = [
      // {
      //   key: 'creditAnalysisComment',
      //   label: '',
      //   value: '',
      //   type: 'textarea',
      //   rules: [
      //     {
      //       min: 0,
      //       max: 20000,
      //       message: 'No more than 20000 characters.',
      //       trigger: 'blur',
      //     },
      //   ],
      // },
    ]
    const otherKeys = ['requestTypeStr', 'applyTypeStr']
    const creditLineKeys = ['typeStr', 'indateEnd', 'amount', 'requestTypeStr']
    const decisionFormModel = [
      {
        label: 'Credit Request Type',
        type: 'select',
        key: 'requestType',
        disabled: true,
        rules: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        selectList: [
          {
            id: 1,
            name: 'Line Of Credit',
          },
          {
            id: 2,
            name: 'Other',
          },
        ],
      },
      {
        label: 'Credit Category',
        key: 'type',
        type: 'select',
        value: '',
        disabled: false,
        rules: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        selectList: [
          { id: 1, name: 'BAU' },
          { id: 2, name: 'Uplift' },
        ],
      },
      {
        style: { display: 'block' },
        label: 'Approved Limit ',
        rules: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        type: 'input',
        key: 'amount',
        disabled: false,
        value: '',
        input: value => this.handleChange(value),
      },
      {
        style: { display: 'block' },
        label: 'Partial Amount',
        type: 'input',
        key: 'partialAmount',
        disabled: false,
        value: '',
        input: value2 => this.handleValueChange(value2),
      },
      {
        label: 'Decision Type',
        rules: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        type: 'select',
        value: '',
        disabled: false,
        key: 'decisionType',
        change: (val, form) => this.handleDecisionSelect(val, form),
        selectList: [
          { id: 1, name: 'Final Approved' },
          { id: 2, name: 'Declined' },
          { id: 3, name: 'Pending' },
          { id: 4, name: 'Conditional Approval' },
          { id: 5, name: 'Cancelled' },
          { id: 8, name: 'Field Action' },
        ],
      },
      {
        value: '',
        label: 'Expire Date',
        rules: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        type: 'date',
        key: 'indateEnd',
        style: { display: 'block' },
      },
      // {
      //   value: '',
      //   label: 'Comments',
      //   type: 'textarea',
      //   key: 'decisionComments',
      //   rules: [
      //     {
      //       min: 0,
      //       max: 20000,
      //       message: 'No more than 20000 characters.',
      //       trigger: 'blur',
      //     },
      //   ],
      // },
    ]
    // const resignFormModel = [
    //   {
    //     label: '',
    //     key: 'activeName',
    //     type: 'vagueActiveName',
    //   },
    // ]
    return {
      uploadUrl: `${config.baseApi}/workflow-api/credit-apply/attachment/upload`,
      allInfo: {},
      basicInfoKeys,
      basicInfoData: [],
      outerKeys,
      disabled: false,
      outsideInfo: [],
      auditDetail: [], // current credit line 字段
      companyDetailKeys,
      companyDetailInfo: [],
      isJapan: false, // 是否是日本公司
      companydata: [],
      otherKeys,
      japanInfo: [],
      japanKeys, // 日本公司数据info
      riskKeys1,
      riskKeys2,
      riskInfo1: [], // risk info & keys
      riskInfo2: [], // risk info & keys
      scoreKeys,
      scoreInfo: [], // score info & keys
      creditLineKeys,
      creditLineInfo: [], // credit line info & keys
      requestDetailInfo: [], // request detail info & keys
      submitFormModel,
      commentsModel,
      decisionFormModel,
      processData: [],
      showResign: false,
      anaFileList: [], // ana 上传文件列表
      decisionFileList: [], // decision 上传文件列表
      anaForm: { type: '' },
      submitterFileList: [], // submitter 文件列表
      auditStatus: 0,
      // 审核的状态，1-WQ(pending)(3btn)；2-Success(manualapp)(1btn-Update)；3-Reject&4-Cancel(0btn);5-AutoRules(0btn3info+submit&files)
      // decisionTxtArea: '', // decision 的 textarea
      showAddition: false,
      conditionTypeList: [], // addition conditions的下拉列表
      conditionNameList: [],
      conditionRes: [], // addition condition 的form表单数据(所有)
      additionalForm: { selectedConditions: [] }, // 将additional conditions的select设置成一个form表单，以提供必选功能
      additionalRules: {},
      reassignForm: {
        reassignName: '',
      },
      optionsActiveName: [],
      isReassignBtn: true,
      isResubmitBtn: true,
      isSaveBtn: true,
      isUpdateBtn: true,
      isUpdateDecisionBtn: true,
      decisionType_: '',
      additionalConditionsVOList: [],
      isLoading: false, // Update Decision点击的时候需要延迟2s,否则work-queue列表来不及显示
      content: '',
      analystComments: '',
      decisionComment: '',
      token: '',
      requestType_: '',
    }
  },
  beforeDestroy() {
    this.timer = null
    clearTimeout(this.timer)
  },
  computed: {
    _basicInfoData() {
      return [
        ...this.basicInfoData,
        ...this.outsideInfo,
        ...this.auditDetail,
        ...this.companyDetailInfo,
      ].map(item => {
        item.key = mixins.methods.transLabelToName(item.key)
        const filter = [
          'Valid Amount',
          'Average Overdue Ratio in last 12 mths(%)',
          'Overdue Amount >= 60 Days',
          'Total AR',
          'Total Exposure',
          'Total Backlog',
        ]
        if (filter.includes(item.key)) {
          item.value = this.$utils.formatAmount(item.value)
        }
        return item
      })
    },
    _japanInfo() {
      return this.japanInfo.map(item => {
        item.key = mixins.methods.transLabelToName(item.key)
        const filter = [
          'Latest Financial Year Total Profit',
          'Latest Financial Year Total Revenue',
          'Overdue Amount >= 60 Days',
          'Total Overdue AMT >= 60 Days',
          'Latest Financial Year Total Capital',
        ]
        if (filter.includes(item.key)) {
          item.value = this.$utils.formatAmount(item.value)
        }
        return item
      })
    },
    _scoreInfo() {
      return this.scoreInfo.map(item => {
        item.key = mixins.methods.transLabelToName(item.key)
        const filter = ['Theoretical Limit']
        if (filter.includes(item.key)) {
          item.value = this.$utils.formatAmount(item.value)
        }
        return item
      })
    },
    _creditLineInfo() {
      return this.creditLineInfo.map(item => {
        item.key = mixins.methods.transLabelToName(item.key)
        if (item.key === 'Credit Limit Amount') {
          item.value = this.$utils.formatAmount(item.value)
        }
        return item
      })
    },
    _requestDetailInfo() {
      return this.requestDetailInfo.map(item => {
        item.key = mixins.methods.transLabelToName(item.key)
        if (item.key === 'Request Amount($)') {
          item.value = this.$utils.formatAmount(item.value)
        }
        return item
      })
    },
  },
  mounted() {
    const auditParams = {
      bpmId: this.$route.query.bpmId,
    }
    this._getCssDetail(auditParams)
    this._getAdditionList()
    this.token = this.$storage.getItem('token')
  },
  methods: {
    async handleChange(value) {
      value = this.$utils.setSeperatenum(value)
      this.decisionFormModel = this.decisionFormModel.map(item => {
        if (item.key === 'amount') {
          item.value = value
        }
        return item
      })
    },
    async handleValueChange(value2) {
      value2 = this.$utils.setSeperatenum(value2)
      this.decisionFormModel = this.decisionFormModel.map(item => {
        if (item.key === 'partialAmount') {
          item.value = value2
        }
        return item
      })
    },
    a(item1) {
      console.log(item1)
      return item1.map(item => ({
        key: mixins.methods.transLabelToName(item.key),
        value:
          item.key === 'collateralAmount' || item.key === 'insuranceAmount'
            ? this.$utils.formatAmount(item.value)
            : item.value,
      }))
    },
    async goSnapShot(data) {
      await this.$storage.setItem('customerInfo', {
        name: data.name,
        address: data.address,
        code: data.code,
        country: data.countryStr,
        city: data.city,
        state: data.state,
      })
      let routeUrl = this.$router.resolve({
        path: `/customer-management/${data.id}/info/snapshot`, // 对应路由
      })
      window.open(routeUrl.href, '_blank')
      const params = {
        companyId: data.id,
      }
      await getAddlog(params)
    },
    async _getCssDetail(params) {
      try {
        const res = await getCssDetail(params)
        // 如果已经保存的decision type === 4 // 回显additional conditions
        this.decisionType_ = res.creditInfo.decisionType
        this.requestType_ = res.creditInfo.requestType
        if (
          this.decisionType_ === 2 ||
          this.decisionType_ === 5 ||
          this.decisionType_ === 8
        ) {
          this.decisionFormModel.forEach(item => {
            if (
              item.key === 'amount' ||
              item.key === 'indateEnd' ||
              item.key === 'partialAmount'
            ) {
              item.style.display = 'none'
            }
          })
        } else {
          this.decisionFormModel.forEach(item => {
            if (
              item.key === 'amount' ||
              item.key === 'indateEnd' ||
              item.key === 'partialAmount'
            ) {
              item.style.display = 'block'
            }
          })
        }
        this.additionalConditionsVOList = res.additionalConditionsVOList
        // 回显additional select list
        this.additionalForm.selectedConditions =
          res.additionalConditionsVOList.map(item => item.conditionType)
        // 回显conditionNameList
        if (
          this.decisionType_ === 4 ||
          this.decisionType_ === 1 ||
          this.decisionType_ === 3 ||
          this.decisionType_ === 8
        ) {
          this.conditionNameList = res.additionalConditionsVOList.map(
            item => item.conditionTypeStr,
          )
          console.log(this.conditionNameList, 111)
        }
        // 根据接口返回值动态显示btn area
        this.isReassignBtn = res.isReassignBtn
        this.isResubmitBtn = res.isResubmitBtn
        this.isSaveBtn = res.isSaveBtn
        this.isUpdateBtn = res.isUpdateBtn
        this.isUpdateDecisionBtn = res.isUpdateDecisionBtn
        // 回显decisions的credit category
        if (res.creditInfo.requestType === 2) {
          this.decisionFormModel = this.decisionFormModel.map(item => {
            if (item.key === 'amount') {
              item.style.display = 'none'
              delete item.rules
            } else if (item.key === 'partialAmount') {
              item.style.display = 'none'
            } else if (item.key === 'indateEnd') {
              item.style.display = 'none'
              delete item.rules
            }
            return item
          })
          this.decisionFormModel = this.decisionFormModel.map(item => {
            if (item.key === 'type') {
              item = {
                ...item,
                selectList: [
                  { id: 4, name: 'PCR' },
                  { id: 5, name: 'Condition Update' },
                  { id: 6, name: 'Waiver' },
                  { id: 7, name: 'Invoice Extension' },
                ],
              }
            }
            return item
          })
        }
        // ----- 获取此审核的status，赋值给this.auditStatus
        this.auditStatus = res.creditInfo.status
        // 回显decision的textarea
        // 抽出decisions form需要回显的数据
        const _decisionKeys = Object.keys(res.creditInfo)
        const _decisionFormModel = this.decisionFormModel.map(item => {
          if (_decisionKeys.indexOf(item.key) !== -1) {
            item.value = res.creditInfo[item.key]
            if (item.key === 'indateEnd') {
              // item.value = item.key
              // item.value = dayjs().subtract(-1, 'year').format('YYYY-MM-DD')
            }
            if (item.key === 'decisionComments') {
              if (
                item.value.includes('&gt;') ||
                item.value.includes('&lt;') ||
                item.value.includes('\n')
              ) {
                item.value = item.value.replace(/&lt;/g, '<')
                item.value = item.value.replace(/&gt;/g, '>')
                item.value = item.value.replace(/\n/g, '<br/>')
              }
            }
            item.label === 'Approved Limit ' || item.label === 'Partial Amount'
              ? (item.value = this.$utils.formatAmount(
                  res.creditInfo[item.key],
                ))
              : res.creditInfo[item.key]
          }
          return item
        })
        // 在manual approved的时候将两个select置为disabled
        if (this.auditStatus === 2) {
          _decisionFormModel[0].disabled = true
          _decisionFormModel[4].disabled = true
        }
        console.log(_decisionFormModel)
        this.decisionFormModel = _decisionFormModel
        // ___将ana和decision的文件回显
        this.anaFileList = res.attachments
          .filter(item => item.fileType === 2)
          .map(item => ({
            name: item.fileName,
            url: item.url,
            id: item.id,
          }))
        this.decisionFileList = res.attachments
          .filter(item => item.fileType === 3)
          .map(item => ({
            name: item.fileName,
            url: item.url,
            id: item.id,
          }))
        // ---
        // 取出credit line的信息
        const __auditArr = []
        // const obj = {}
        // obj.key = 'validAmount'
        // obj.value = res['validAmount']
        // __auditArr.push(obj)
        this.auditDetail = __auditArr
        // 操作credit line 数据
        const _creditLine = []
        Object.keys(res.historyAmount).forEach(key => {
          if (this.creditLineKeys.indexOf(key) !== -1) {
            const obj = {}
            obj.key = key
            obj.value = res.historyAmount[key]
            _creditLine.push(obj)
          }
        })
        this.creditLineInfo = _creditLine
        // ___ 文件列表
        this.submitterFileList = res.attachments
          .filter(item => item.fileType === 1)
          .map(item => ({
            name: item.fileName,
            url: item.url,
            id: item.id,
          }))
        // take request detail
        const _requestDetailInfo = []
        Object.keys(res.creditInfo).forEach(key => {
          if (res.creditInfo.requestType === 1) {
            if (
              key === 'applyAmount' ||
              key === 'applyTypeStr' ||
              key === 'requestTypeStr'
            ) {
              const _obj = {
                key: key === 'applyAmount' ? 'amountDetail' : key,
                value: res.creditInfo[key],
              }
              _requestDetailInfo.push(_obj)
            }
          } else {
            if (this.otherKeys.indexOf(key) !== -1) {
              const _obj = {}
              _obj.key = key
              _obj.value = res.creditInfo[key]
              _requestDetailInfo.push(_obj)
            }
          }
        })
        this.requestDetailInfo = _requestDetailInfo
        // take process
        this.processData = res.process
        this.processData.map(item => {
          if (item.taskName === 'Manual Approver') {
            item.taskName = 'Final Approver'
          }
        })
        // 回显remark
        if (
          res.creditInfo.remark.includes('&gt;') ||
          res.creditInfo.remark.includes('&lt;') ||
          res.creditInfo.remark.includes('\n')
        ) {
          res.creditInfo.remark = res.creditInfo.remark.replace(/&lt;/g, '<')
          res.creditInfo.remark = res.creditInfo.remark.replace(/&gt;/g, '>')
          res.creditInfo.remark = res.creditInfo.remark.replace(/\n/g, '<br/>')
        }
        this.content = res.creditInfo.remark
        if (
          res.creditInfo.decisionComments.includes('&gt;') ||
          res.creditInfo.decisionComments.includes('&lt;') ||
          res.creditInfo.decisionComments.includes('\n')
        ) {
          res.creditInfo.decisionComments =
            res.creditInfo.decisionComments.replace(/&lt;/g, '<')
          res.creditInfo.decisionComments =
            res.creditInfo.decisionComments.replace(/&gt;/g, '>')
          res.creditInfo.decisionComments =
            res.creditInfo.decisionComments.replace(/\n/g, '<br/>')
        }
        this.decisionComment = res.creditInfo.decisionComments
        // this.submitFormModel = [
        //   {
        //     ...this.submitFormModel[0],
        //     value: res.creditInfo.remark,
        //   },
        // ]
        // 回显credit analysis comments
        if (
          res.creditInfo.creditAnalystComments.includes('&gt;') ||
          res.creditInfo.creditAnalystComments.includes('&lt;') ||
          res.creditInfo.creditAnalystComments.includes('\n')
        ) {
          res.creditInfo.creditAnalystComments =
            res.creditInfo.creditAnalystComments.replace(/&lt;/g, '<')
          res.creditInfo.creditAnalystComments =
            res.creditInfo.creditAnalystComments.replace(/&gt;/g, '>')
          res.creditInfo.creditAnalystComments =
            res.creditInfo.creditAnalystComments.replace(/\n/g, '<br/>')
        }
        this.analystComments = res.creditInfo.creditAnalystComments
        // this.commentsModel = [//   {//     ...this.commentsModel[0],//     value: res.creditInfo.creditAnalystComments,
        //   },
        // ]
        // 请求工作流审批客户详情
        await this._getCusInfo(res.creditInfo.companyId)
      } catch (err) {
        console.log(err)
      }
    },
    async _getCusInfo(id) {
      try {
        const params = {
          id,
        }
        const res = await getCusInfo(params)
        this.companydata = res.companyInfoVO
        this.allInfo = res
        this.filterData(res)
      } catch (err) {
        console.log(err)
      }
    },
    //对数据进行摘取
    filterData(allData) {
      // 如果是日本
      if (allData.companyInfoVO.countryStr === 'Japan') {
        this.isJapan = true
        if (allData.companyJapanDetailVO) {
          const _japanInfo = []
          this.japanInfo = this.handleKeys(
            allData.companyJapanDetailVO,
            _japanInfo,
            this.japanKeys,
          )
        }
      }
      // 对外层数据进行操作，之后合并一起传给r-form
      const _outArr = []
      Object.keys(allData).forEach(key => {
        if (this.outerKeys.indexOf(key) !== -1) {
          const _obj = {}
          _obj.key = key
          _obj.value = allData[key]
          _outArr.push(_obj)
        }
      })
      this.outsideInfo = _outArr
      // 对 customer basic info操作
      if (allData.companyInfoVO) {
        const _basicInfoData = []
        this.basicInfoData = this.handleKeys(
          allData.companyInfoVO,
          _basicInfoData,
          this.basicInfoKeys,
        )
      }
      // 对company detail 数据进行操作
      if (allData.companyDetailVO) {
        const _companyDetailInfo = []
        this.companyDetailInfo = this.handleKeys(
          allData.companyDetailVO,
          _companyDetailInfo,
          this.companyDetailKeys,
        )
      }
      console.log(allData.riskMitigationVO)
      // 对risk数据进行操作
      if (allData.riskMitigationVO) {
        const InsurancesArr = allData.riskMitigationVO.companyInsurances
        const AssurancesArr = allData.riskMitigationVO.companyAssurances

        for (let item = 0; item < AssurancesArr.length; item++) {
          const _riskInfo1 = []
          this.riskInfo1.push(
            this.handleKeys(AssurancesArr[item], _riskInfo1, this.riskKeys1),
          )
        }
        for (let index = 0; index < InsurancesArr.length; index++) {
          const _riskInfo2 = []
          this.riskInfo2.push(
            this.handleKeys(InsurancesArr[index], _riskInfo2, this.riskKeys2),
          )
        }
      }
      // 对financial scores 进行操作
      if (allData.financialScoresVO) {
        const _scoreInfo = []
        this.scoreInfo = this.handleKeys(
          allData.financialScoresVO,
          _scoreInfo,
          this.scoreKeys,
        )
      }
    },
    // 提出来function handle keys
    handleKeys(dataObj, targetArr, keysArr) {
      Object.keys(dataObj).forEach(key => {
        if (keysArr.indexOf(key) !== -1) {
          const obj = {}
          obj.key = key
          obj.value = dataObj[key]
          targetArr.push(obj)
        }
      })
      return targetArr
    },
    // 底部button事件
    async handleSave() {
      /* 遍历选中的form,通过this.$refs.变量拿到dom元素, 通过getFormData拿到表单值,
       * 因为不能给子form传id,并且接口需要conditionType(id),所以又通过表单name去遍历获取id*/
      const _conditionRes = []
      this.conditionNameList.forEach(item => {
        const curFormData = this.$refs[`${item}`].getFormData()
        const _res = { conditionType: '' }
        Object.keys(curFormData).forEach(key => {
          if (key === 'formName') {
            this.conditionTypeList.forEach(item => {
              if (item.name === curFormData['formName']) {
                _res.conditionType = item.id
              }
            })
          }
          delete _res.formName
          _res[key] = curFormData[key]
        })
        _conditionRes.push(_res)
      })
      this.conditionRes = _conditionRes
      // 处理decision的数据
      const _loanAmount = { ...this.$refs.decisionForm.getFormData() }
      _loanAmount.amount = this.$utils.resetAmount(_loanAmount.amount)
      _loanAmount.partialAmount = this.$utils.resetAmount(
        _loanAmount.partialAmount,
      )
      const obj = JSON.parse(JSON.stringify(_loanAmount))
      delete obj.decisionComments
      delete _loanAmount.source
      // 第一次进来可能不会有decision 应要求Save不验证必填
      const isValid = await this.$refs.analysisComments.validateFields()
      console.log(isValid)
      const params = {
        attachmentAnalystIds: this.anaFileList.length
          ? this.anaFileList.map(file => file.response?.data || file.id)
          : [],
        attachmentDecisionIds: this.decisionFileList.length
          ? this.decisionFileList.map(file => file.response?.data || file.id)
          : [],
        bpmId: this.$route.query.bpmId,
        creditAnalystComments: this.$refs.quillEditor.getContent().trim(),
        decisionComments: this.$refs.decisionComments.getContent().trim(),
        loanAmount: obj,
        creditBpmAdditionalConditionsBOList: this.conditionRes,
      }
      if (this.showAddition) {
        await this.$refs.additionalForm.validate(async isValid => {
          if (isValid) {
            try {
              const rules = [
                'AFS',
                'AREV',
                'BG',
                'CERT',
                'CI',
                'CMA',
                'COVT',
                'DP',
                'F43',
                'F72',
                'FCOV',
                'GLPG',
                'GPG',
                'HFS',
                'HREV',
                'MSC1',
                'MSC2',
                'MSC3',
                'PFIN',
                'PN',
                'BCL',
                'POWC',
                'PT1',
                'QFS',
                'QREV',
                'REF',
                'ROT',
                'SBLC',
                'SG',
                'TC',
                'TRX',
                'UPL',
                'VT1',
                'XROT',
                'ARD',
              ]
              const arr = []
              for (const item of rules) {
                const ref = this.$refs[item]

                if (ref && ref.checkValid) {
                  arr.push(await ref.checkValid())
                }
              }
              if (!arr.includes(false)) {
                await finalAuditSave(params)
                this.$message.success('success')
              }
            } catch (err) {
              console.log(err)
            }
          }
        })
      } else {
        try {
          await finalAuditSave(params)
          this.$message.success('success')
        } catch (err) {
          console.log(err)
        }
      }
    },
    async handleUpdate(isCompleted) {
      /* 遍历选中的form,通过this.$refs.变量拿到dom元素, 通过getFormData拿到表单值,
       * 因为不能给子form传id,并且接口需要conditionType(id),所以又通过表单name去遍历获取id*/
      const _conditionRes = []
      console.log(this.conditionNameList)
      this.conditionNameList.forEach(item => {
        const curFormData = this.$refs[`${item}`].getFormData()
        const _res = { conditionType: '' }
        Object.keys(curFormData).forEach(key => {
          if (key === 'formName') {
            this.conditionTypeList.forEach(item => {
              if (item.name === curFormData['formName']) {
                _res.conditionType = item.id
              }
            })
          }
          delete _res.formName
          _res[key] = curFormData[key]
        })
        _conditionRes.push(_res)
      })
      this.conditionRes = _conditionRes
      // 处理decision的数据
      const isValid = await this.$refs.decisionForm.validateFields()
      const Valid = await this.$refs.analysisComments.validateFields()
      console.log(Valid)
      const _loanAmount = { ...this.$refs.decisionForm.getFormData() }
      _loanAmount.amount = this.$utils.resetAmount(_loanAmount.amount)
      _loanAmount.partialAmount = this.$utils.resetAmount(
        _loanAmount.partialAmount,
      )
      const obj = JSON.parse(JSON.stringify(_loanAmount))
      delete obj.decisionComments
      delete _loanAmount.source
      const params = {
        attachmentAnalystIds: this.anaFileList.length
          ? this.anaFileList.map(file => file.response?.data || file.id)
          : [],
        attachmentDecisionIds: this.decisionFileList.length
          ? this.decisionFileList.map(file => file.response?.data || file.id)
          : [],
        bpmId: this.$route.query.bpmId,
        creditAnalystComments: this.$refs.quillEditor.getContent().trim(),
        decisionComments: this.$refs.decisionComments.getContent().trim(),
        loanAmount: obj,
        creditBpmAdditionalConditionsBOList: this.conditionRes,
      }
      // 需要检查两个form表单。当选择condition approved的时候,新出来的表单也要check isValid
      // 所以分两种情况: 一种是需要additional表单(showAddition=true),另一种不需要additional,直接check外层表单
      if (this.showAddition) {
        this.$refs.additionalForm.validate(async isValid => {
          if (isValid) {
            this.isLoading = true
            try {
              if (isCompleted) {
                const rules = [
                  'AFS',
                  'AREV',
                  'BG',
                  'CERT',
                  'CI',
                  'CMA',
                  'COVT',
                  'DP',
                  'F43',
                  'F72',
                  'FCOV',
                  'GLPG',
                  'GPG',
                  'HFS',
                  'HREV',
                  'MSC1',
                  'MSC2',
                  'MSC3',
                  'PFIN',
                  'PN',
                  'BCL',
                  'POWC',
                  'PT1',
                  'QFS',
                  'QREV',
                  'REF',
                  'ROT',
                  'SBLC',
                  'SG',
                  'TC',
                  'TRX',
                  'UPL',
                  'VT1',
                  'XROT',
                  'ARD',
                ]
                const arr = []
                for (const item of rules) {
                  const ref = this.$refs[item]
                  if (ref && ref.checkValid) {
                    arr.push(await ref.checkValid())
                  }
                }
                if (!arr.includes(false)) {
                  await getCompletedUpdate(params)
                }
              } else {
                const rules = [
                  'AFS',
                  'AREV',
                  'BG',
                  'CERT',
                  'CI',
                  'CMA',
                  'COVT',
                  'DP',
                  'F43',
                  'F72',
                  'FCOV',
                  'GLPG',
                  'GPG',
                  'HFS',
                  'HREV',
                  'MSC1',
                  'MSC2',
                  'MSC3',
                  'PFIN',
                  'PN',
                  'BCL',
                  'POWC',
                  'PT1',
                  'QFS',
                  'QREV',
                  'REF',
                  'ROT',
                  'SBLC',
                  'SG',
                  'TC',
                  'TRX',
                  'UPL',
                  'VT1',
                  'XROT',
                  'ARD',
                ]
                const arr = []
                for (const item of rules) {
                  const ref = this.$refs[item]
                  if (ref && ref.checkValid) {
                    arr.push(await ref.checkValid())
                  }
                }
                if (!arr.includes(false)) {
                  await cssAudit(params)
                }
              }
              this.timer = setTimeout(() => {
                this.isLoading = false
                this.$message.success('success')
                this.$router.push('/work-queue')
              }, 2000)
            } catch (err) {
              this.isLoading = false
              console.error(err)
            }
          } else {
            return false
          }
        })
      } else {
        if (isValid) {
          // 延迟两秒
          this.isLoading = true
          try {
            //如果Decision Type===Declined&&Cancelled时,清空ADDITIONAL CONDITIONS数据

            if (isCompleted) {
              await getCompletedUpdate(params)
            } else {
              await cssAudit(params)
            }
            this.isLoading = false
            this.$message.success('success')
            this.$router.push('/work-queue')
          } catch (err) {
            this.isLoading = false
            console.error(err)
          }
        }
      }
    },
    // 派发
    async handleResign() {
      try {
        const params = {
          assignTo: this.reassignForm.reassignName,
          bpmIds: [this.$route.query.bpmId],
        }
        await resignAudit(params)
        this.$message.success('success')
        this.showResign = false
      } catch (err) {
        console.log(err)
      }
    },
    handleAnaChange(file) {
      if (!file.response) {
        const size = file.size / 1024
        if (size < 50000) {
          this.anaFileList.push(file)
        } else {
          this.$message.error('File must not exceed 50M')
          this.anaFileList = [...this.anaFileList] // 重置列表，如果不重置会出现第五个超出体积再传符合的传不上去
        }
      }
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    handleRemove(file, fileList) {
      this.anaFileList = fileList
    },
    handleDecRemove(file, fileList) {
      this.decisionFileList = fileList
    },
    anaUploadSuccess({ code, msg }) {
      if (code === ERR_OK) {
        this.$message.success('success')
      } else {
        this.$message.error(msg)
        this.anaFileList.pop()
      }
    },
    handleBeyond() {
      this.$message.warning('No more than 5 attachments!')
    },
    handleNewBeyond() {
      this.$message.warning('No more than 15 attachments!')
    },
    handleDecisionChange(file) {
      if (!file.response) {
        const size = file.size / 1024
        if (size < 50000) {
          this.decisionFileList.push(file)
        } else {
          this.$message.error('File must not exceed 50M')
          this.decisionFileList = [...this.decisionFileList] // 重置列表，如果不重置会出现第五个超出体积再传符合的传不上去
        }
      }
    },
    decisionUploadSuccess({ code, msg }) {
      if (code === ERR_OK) {
        this.$message.success('success')
      } else {
        this.$message.error(msg)
        this.decisionFileList.pop()
      }
    },
    async handlePreview(fileList) {
      try {
        const params = {
          id: fileList.id,
        }
        await getFile(params)
      } catch (err) {
        console.log(err)
      }
    },
    async fileClick(fileList) {
      try {
        const params = {
          id: fileList.id,
        }
        await getFile(params)
      } catch (err) {
        console.log(err)
      }
    },
    async handleDecisionSelect(val) {
      this.decisionType_ = val
      if (this.requestType_ === 1) {
        if ([2, 5, 8].includes(val)) {
          this.decisionFormModel.forEach(item => {
            if (
              item.key === 'amount' ||
              item.key === 'indateEnd' ||
              item.key === 'partialAmount'
            ) {
              item.style.display = 'none'
              item.rules = []
            }
          })
        } else {
          this.decisionFormModel.forEach(item => {
            if (
              item.key === 'amount' ||
              item.key === 'indateEnd' ||
              item.key === 'partialAmount'
            ) {
              item.style.display = 'block'
              if (item.key === 'partialAmount') {
                item.rules = [
                  {
                    message: 'Can not be empty!',
                    trigger: 'blur',
                  },
                ]
              } else {
                item.rules = [
                  {
                    required: true,
                    message: 'Can not be empty!',
                    trigger: 'blur',
                  },
                ]
              }
            }
          })
        }
      } else {
        if ([1, 2, 4, 5, 8].includes(val)) {
          this.decisionFormModel.forEach(item => {
            if (
              item.key === 'amount' ||
              item.key === 'indateEnd' ||
              item.key === 'partialAmount'
            ) {
              item.style.display = 'none'
              item.rules = []
            }
          })
        } else {
          this.decisionFormModel.forEach(item => {
            if (
              item.key === 'amount' ||
              item.key === 'indateEnd' ||
              item.key === 'partialAmount'
            ) {
              item.style.display = 'block'
              if (item.key === 'partialAmount') {
                item.rules = [
                  {
                    message: 'Can not be empty!',
                    trigger: 'blur',
                  },
                ]
              } else {
                item.rules = [
                  {
                    required: true,
                    message: 'Can not be empty!',
                    trigger: 'blur',
                  },
                ]
              }
            }
          })
        }
      }
      if ([1, 3, 4, 8].includes(val)) {
        this.showAddition = true
        // this.additionalForm = {}
        // this.conditionNameList = []
        // this.additionalConditionsVOList = []
      } else {
        this.showAddition = false
        // this.additionalForm = {}
        // this.conditionNameList = []
        // this.additionalConditionsVOList = []
      }
    },
    // 获取addition conditions 下拉列表
    async _getAdditionList() {
      try {
        this.conditionTypeList = await getSelectList('ConditionType')
      } catch (err) {
        console.error(err)
      }
    },
    // condition change
    conditionChange(valueList) {
      this.additionalForm.selectedConditions = valueList
      // 因为select的name和id对不上,得需要name来判断显示哪个form所以存一下nameList
      const _conditionNameList = []
      for (const value of valueList) {
        for (const item of this.conditionTypeList) {
          if (item.id === value) {
            _conditionNameList.push(item.name)
          }
        }
      }
      this.conditionNameList = _conditionNameList
    },
    // 模糊查询active name
    async remoteActiveName(query) {
      if (query !== '') {
        try {
          const params = {
            name: query,
          }
          const res = await vagueActiveName(params)
          this.optionsActiveName = res.map(item => ({
            id: item.id,
            label: item.name,
            value: item.username,
          }))
        } catch (err) {
          console.log(err)
        }
      } else {
        this.optionsActiveName = []
      }
    },
  },
}
</script>
<style scoped lang="less">
.container {
  width: 100%;
  .customerId {
    color: blue;
    font-size: 14px;
    cursor: pointer;
  }
  .card {
    width: 100%;
    margin-bottom: 24px;
  }
  .fileItem {
    height: 30px;
    width: 700px;
    cursor: pointer;
    font-size: 14px;
  }
  .fileItem:hover {
    color: #409eff;
  }
  .con-select {
    width: 380px;
    margin-bottom: 20px;
  }
  .label {
    font-size: 14px;
    margin-bottom: 20px;
    margin-top: 40px;
  }
  .processBox {
    width: 100%;
    height: 190px;
    background-color: yellowgreen;
  }
}
.upload {
  width: 100%;
  margin-top: 20px;
  border-radius: 27px;
}
.txtArea {
  width: 700px;
  margin-top: 24px;
}
.btnArea {
  width: 100%;
  display: flex;
  margin-top: 24px;
  button {
    margin-right: 24px;
  }
  justify-content: flex-end;
}
</style>
